module.exports = __webpack_public_path__ + "fonts/apple_svgrepo.com.svg";